(() => {
  const DEBUG = true;
  const log = (...args) => {
    if (!DEBUG) return;
    console.debug("[cart-shield]", ...args);
  };

  let removalInFlight = false;

  const parseList = (value) =>
    (value || "")
      .split(",")
      .map((entry) => entry.trim())
      .filter(Boolean);

  const parseIds = (value) =>
    parseList(value)
      .map((id) => parseInt(id, 10))
      .filter((id) => !Number.isNaN(id));

  const getProductIdsInCart = () =>
    new Set(
      Array.from(document.querySelectorAll("[data-product-id]"))
        .map((el) => parseInt(el.dataset.productId, 10))
        .filter((id) => !Number.isNaN(id)),
    );

  const getProductHandlesInCart = () =>
    new Set(
      Array.from(document.querySelectorAll("[data-product-handle]"))
        .map((el) => (el.dataset.productHandle || "").trim())
        .filter(Boolean),
    );

  const removeLines = async (lines) => {
    const cartComponent =
      document.querySelector("cart-drawer-items") ||
      document.querySelector("cart-items");

    if (cartComponent && typeof cartComponent.updateQuantity === "function") {
      log("Removing via cart component", lines);
      lines.forEach((line) => cartComponent.updateQuantity(line, 0));
      return;
    }

    if (!window.routes || !window.routes.cart_update_url) {
      window.location.reload();
      return;
    }

    const updates = {};
    lines.forEach((line) => (updates[line] = 0));

    try {
      log("Removing via fetch", updates);
      await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({
          updates,
          sections_url: window.location.pathname,
        }),
      });
      if (
        typeof publish === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-shield" });
      }
    } catch (error) {
      console.error("Cart shield removal failed", error);
    }
  };

  const enforceCartShield = () => {
    if (removalInFlight) return;

    const shieldedItems = Array.from(
      document.querySelectorAll("[data-cart-shield]"),
    );
    const shieldedHandleItems = Array.from(
      document.querySelectorAll("[data-cart-shield-handles]"),
    ).filter((el) => !shieldedItems.includes(el));
    const candidates = [...new Set([...shieldedItems, ...shieldedHandleItems])];

    if (!candidates.length) {
      log("No shielded items found");
      return;
    }

    const productIds = getProductIdsInCart();
    const productHandles = getProductHandlesInCart();
    const linesToCull = [];

    log("Cart snapshot", {
      productIds: Array.from(productIds),
      productHandles: Array.from(productHandles),
      candidates: candidates.map((el) => ({
        line: el.dataset.line,
        productId: el.dataset.productId,
        productHandle: el.dataset.productHandle,
        shieldIds: el.dataset.cartShield,
        shieldHandles: el.dataset.cartShieldHandles,
      })),
    });

    candidates.forEach((item) => {
      const requiredIds = parseIds(item.dataset.cartShield);
      const requiredHandles = parseList(item.dataset.cartShieldHandles);
      if (!requiredIds.length && !requiredHandles.length) return;

      const hasAnchor =
        requiredIds.some((id) => productIds.has(id)) ||
        requiredHandles.some((handle) => productHandles.has(handle));
      if (!hasAnchor) {
        const line = parseInt(item.dataset.line, 10);
        if (!Number.isNaN(line)) linesToCull.push(line);
        log("Queued for removal", {
          line,
          productId: item.dataset.productId,
          productHandle: item.dataset.productHandle,
          requiredIds,
          requiredHandles,
        });
      }
    });

    if (!linesToCull.length) return;

    log("Removing lines", linesToCull);
    removalInFlight = true;
    removeLines([...new Set(linesToCull)]).finally(() => {
      removalInFlight = false;
    });
  };

  const scheduleEnforce = () =>
    window.requestAnimationFrame(() => enforceCartShield());

  document.addEventListener("DOMContentLoaded", scheduleEnforce);

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleEnforce);
  }

  document.addEventListener("cart-drawer:render", scheduleEnforce);
})();
